











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DescriptionComponent extends Vue {
    @Prop() private content!: string;
    @Prop() private source!: string;
}
